import React from 'react';
import { useScrollProgress } from '../../hooks/useScrollProgress';

export default function ScrollProgressBar() {
  const progress = useScrollProgress();

  return (
    <div className="fixed top-0 left-0 right-0 z-[1001] h-[3px] bg-transparent pointer-events-none">
      <div
        className="h-full bg-gradient-to-r from-teal to-teal-light transition-none"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
}
